import get from "lodash/get";

import { Alert } from "cortex/ui/src/fleet/view/alert/model";
import { defaultObject } from "cortex/ui/src/redux-store/selectors";
import { StoreStatus, storesReady } from "cortex/ui/src/redux-store/utils";

type AlertsById = Record<string | number, Alert>;

interface RootAlertsState {
  app?: {
    alertsV3?: StoreStatus;
  };
}

export function alertsSelector(state: unknown): AlertsById {
  return get(state, "app.alertsV3.byId", defaultObject);
}

export function alertsStoresLoadedSelector(state: unknown): boolean {
  const typedState = state as RootAlertsState;
  return storesReady(typedState.app?.alertsV3);
}
